import { useNavigate } from "react-router-dom";

export default function UserAgreement() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 px-4 py-4">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => navigate(-1)}
          className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center cursor-pointer shrink-0">
          <i className="ri-arrow-left-s-line text-foreground-600 text-sm" />
        </button>
        <h1 className="text-base font-bold text-foreground-950">用户协议</h1>
      </div>

      <div className="bg-white rounded-xl p-4 border border-background-200/60 space-y-5 text-xs text-foreground-600 leading-relaxed">
        <p>欢迎使用 天鼎AI AI 模拟投资平台（以下简称"本平台"或"我们"）。本协议是您与本平台之间关于使用本平台服务的有效协议。请您仔细阅读以下条款，使用本平台服务即表示您已接受本协议的全部条款。</p>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第一条 服务说明</h2>
          <div className="space-y-1.5">
            <p>1.1 本平台提供 AI 多智能体模拟炒股演示功能。所有"买入/卖出/持仓"决策均为 AI 在模拟资金账户中产生的情景推演，不涉及任何真实资金、证券账户或实盘交易。</p>
            <p>1.2 本平台提供的所有数据、图表、分析结果仅供学习参考，不构成任何形式的投资建议。</p>
            <p>1.3 本平台保留根据运营需要随时修改、暂停或终止服务的权利，但将提前通过公告通知用户。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第二条 用户注册与账号</h2>
          <div className="space-y-1.5">
            <p>2.1 用户需提供真实有效的手机号码完成注册，每个手机号仅可注册一个账号。</p>
            <p>2.2 用户应妥善保管账号密码及验证码。因账号泄露、密码保管不当导致的损失由用户自行承担。</p>
            <p>2.3 用户不得将其账号出借、转让或用于任何商业用途。如发现账号异常使用，本平台有权暂停服务。</p>
            <p>2.4 用户注册即表示同意接收本平台通过短信发送的账号安全通知和必要的服务提醒。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第三条 使用规则与用户行为规范</h2>
          <div className="space-y-1.5">
            <p>3.1 用户不得利用本平台从事任何违法违规活动，包括但不限于：传播违法信息、侵犯他人权益、干扰平台正常运行等。</p>
            <p>3.2 用户不得对本平台的软件、API 接口进行反向工程、破解或未经授权的访问。</p>
            <p>3.3 用户不得使用自动化脚本、爬虫或类似技术批量访问本平台服务。</p>
            <p>3.4 用户理解并确认，AI 生成的研究报告、交易信号等均基于算法模型和历史数据，不代表未来表现，不应作为实际投资决策的依据。</p>
            <p>3.5 违反上述规则的用户，本平台有权在不事先通知的情况下暂停或终止其账号。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第四条 知识产权</h2>
          <div className="space-y-1.5">
            <p>4.1 本平台的所有内容，包括但不限于文字、图表、软件、API 接口、UI 设计、算法模型等，均受《中华人民共和国著作权法》《商标法》及相关知识产权法律的保护。</p>
            <p>4.2 未经本平台书面许可，任何用户不得以任何方式复制、传播、修改、翻译或创建与本平台内容相关的衍生作品。</p>
            <p>4.3 本平台使用的"天鼎AI"等商标及标识，均为本平台所有，未经授权不得使用。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第五条 免责声明</h2>
          <div className="space-y-1.5">
            <p>5.1 本平台不对因使用服务而产生的任何直接或间接损失承担责任，包括但不限于因依赖 AI 生成内容导致的投资损失。</p>
            <p>5.2 本平台不对第三方服务的可用性、准确性或安全性承担责任。</p>
            <p>5.3 因不可抗力（包括但不限于自然灾害、战争、政府行为、网络攻击等）导致的服务中断，本平台不承担责任。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第六条 协议变更与终止</h2>
          <div className="space-y-1.5">
            <p>6.1 本平台保留随时修改本协议的权利。修改后的协议将在平台公布，公布即视为生效。如用户不同意修改后的协议，应停止使用本平台服务。</p>
            <p>6.2 用户可随时通过删除账号的方式终止本协议。账号删除后，本平台将在合理期限内删除或匿名化处理用户数据。</p>
          </div>
        </section>

        <section>
          <h2 className="text-sm font-bold text-foreground-950 mb-2">第七条 法律适用与争议解决</h2>
          <div className="space-y-1.5">
            <p>7.1 本协议的订立、执行和解释均适用中华人民共和国法律。</p>
            <p>7.2 因本协议引起的或与本协议有关的任何争议，双方应友好协商解决；协商不成的，提交本平台所在地有管辖权的人民法院诉讼解决。</p>
          </div>
        </section>

        <p className="text-[10px] text-foreground-400 pt-2 border-t border-background-100">版本：V1.0 &#8226; 最后更新：2026年7月</p>
      </div>
    </div>
  );
}
